import ini from './ini';
import slk from './slk';
import m3 from './m3';
import mdlx from './mdlx';
import mpq from './mpq';
import w3x from './w3x';
import blp from './blp';
import dds from './dds';
import tga from './tga';

export default {
  ini,
  slk,
  m3,
  mdlx,
  mpq,
  w3x,
  blp,
  dds,
  tga,
};
